import { Injectable } from '@angular/core';
import { PaginatorResponse, ResponseData } from '@klickdata/core/http';
import { AppScope, Resource, ResourceData, ResourceService } from '@klickdata/core/resource';
import { TableHttpHelpers, TableHttpService, TableSource } from '@klickdata/core/table';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UsersResourcesService extends ResourceService implements TableHttpService<Resource> {
    public fetchData(source: TableSource<Resource>): Observable<ResponseData<Resource[]>> {
        const req = this.builder.get<ResourceData[]>(this.resourceLogUrl);
        TableHttpHelpers.managePagination(source.paginator, req);
        TableHttpHelpers.manageSort(source.sort, req);
        TableHttpHelpers.mapFilter(source.filter, req);

        return req.request().pipe(
            map((res: PaginatorResponse<ResourceData[]>) => {
                return {
                    data: this.mapResource(res.data),
                    notify: res.notify,
                    paginator: res.paginator,
                };
            })
        );
    }
}
